module.exports = __webpack_public_path__ + "temo-be-icon.png?bd0150cd106db3f83972ad837dfa76ac";